import axios from 'axios';
import {useState, useEffect} from 'react';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import Loading from '../../common/Loading';

import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import LoadListListItemReelLockExpire from './LoadListListItemReelLockExpire';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function LoadListListItemLoadLock(props) {
    //console.debug("RTS Break LoadListListItemLoadLock");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");    

    const [showLockExpireModal, setShowLockExpireModal] = useState(false);

    const[data, setData] = useState();
    const[loadLock, setLoadLock] = useState();
    const[lockExpire, setLockExpire] = useState();


    useEffect(() => {
        setData(props.data);
        setLoadLock(props.data.loadLock);
        setLockExpire(props.data.lockExpiration);
        setIsLoading(false);
    }, [props]); 


    function SetLockStatus(){

        let curLock = 0;
        if(loadLock === 0){
            curLock = 1;
        }

        let apiObj = {
            AppUser: user,
            Customer: sessionCustomer.customer,
            Load: data,
            Action: curLock
        }


        let apiURL = apiRoot + "/LoadLocks/LoadLock";
        axios
        .post(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                if(response.data === 1){
                    let locData = data;
                    locData.loadLock = 1;
                    setLoadLock(1);
                    setData(locData);
                    //props.setDataFx(locData);
                }
                else{
                    let locData = data;
                    locData.loadLock = 0;
                    setLoadLock(0);
                    setData(locData);
                    //props.setDataFx(locData);
                }
            }
            else{
                let locData = data;
                locData.loadPin = 0;
                setLoadLock(0);
                setData(locData);
                //props.setDataFx(locData);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
        });
    }

    function SetLockExpireClick(){
        setShowLockExpireModal(true);
    }


    if(isLoading){
        return(
            <Loading />
        );
    };


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog maxWidth="sm" open={showLockExpireModal} onClose={()=>{setShowLockExpireModal(false);}}>
            <DialogTitle>Lock Expiration</DialogTitle>
            <DialogContent>
                <LoadListListItemReelLockExpire load={data} lockExpire={lockExpire} setLockExpireFx={setLockExpire} setShowLockExpireModalFx={setShowLockExpireModal} />
            </DialogContent>
        </Dialog>        
        <Link onClick={SetLockStatus} sx={{textDecoration:'none', cursor:'pointer', display:'flex', alignItems:'center'}}>
        {
        loadLock === 1
        ?
            <>
            <LockIcon sx={{fontSize:'1.5em', color:'red', ml:1, display:'flex', alignItems:'center'}}  />
            </>
        :
            <>
            <LockOpenIcon sx={{fontSize:'1.5em', color:'black', ml:1, display:'flex', alignItems:'center'}}  />
            </>
        }
        </Link>

        {
        loadLock === 1
        ?
            <Link onClick={SetLockExpireClick} sx={{textDecoration:'none', cursor:'pointer', display:'flex', alignItems:'center'}}>
                <CalendarMonthIcon sx={{fontSize:'1.5em', ml:1, display:'flex', alignItems:'center'}}  />
            </Link>
        :
            ""
        }
        </>        
    );
}
